import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { ThemingService } from 'src/app/theming.service';
import { environment } from 'src/environments/environment';
import { LambdaService } from 'src/app/lambda.service';
declare var $: any;

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  @ViewChild('editor') editorElement!: ElementRef;
  modules = {};

  // Bilingual content state
  contentES: string = '';
  contentEN: string = '';
  selectedLanguage: 'es' | 'en' = 'es';
  isENManuallyEdited: boolean = false;
  isTranslating: boolean = false;

  loading = false;
  isEditingPrivacy: boolean = false;

  // Getter/setter for Quill binding
  get currentContent(): string {
    return this.selectedLanguage === 'es' ? this.contentES : this.contentEN;
  }

  set currentContent(value: string) {
    if (this.selectedLanguage === 'es') {
      this.contentES = value;
    } else {
      this.contentEN = value;
      this.isENManuallyEdited = true;
    }
  }

  constructor(
    private appComponent: AppComponent,
    private themingService: ThemingService,
    private lambdaService: LambdaService,
  ) {}

  ngOnInit(): void {
    this.appComponent.goToTop();
    this.loadPolicy();
  }

  private loadPolicy(): Promise<void> {
    return new Promise((resolve) => {
      const url = this.themingService.privacyPolicies + '?t=' + Date.now();
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4 && xhr.status === 200) {
          const response = xhr.responseText;

          try {
            const parsed = JSON.parse(response);
            this.contentES = parsed.es || '';
            this.contentEN = parsed.en || '';
            this.isENManuallyEdited = false;
          } catch {
            this.contentES = response;
            this.contentEN = '';
            this.isENManuallyEdited = false;
          }

          resolve();
        }
      };

      xhr.send();
    });
  }

  selectLanguage(lang: 'es' | 'en'): void {
    this.selectedLanguage = lang;
  }

  switchEditingPrivacy(){
    this.isEditingPrivacy = !this.isEditingPrivacy;
  }

  async savePrivacyPolicy() {
    this.loading = true;

    const stage = environment.stage === 'test' ? 'dev' : environment.stage;

    let finalEN: string | null = this.contentEN;

    if (this.selectedLanguage === 'es') {
      finalEN = null;
      this.isENManuallyEdited = false;
    }

    const payload = JSON.stringify({
      es: this.contentES,
      en: this.isENManuallyEdited ? this.contentEN : finalEN
    });

    this.isTranslating = !this.isENManuallyEdited;

    try {
      await this.lambdaService.uploadHtmlContent(
        `${this.themingService.shopId}/${stage}/config-files/policy-file.html`,
        payload,
        {}
      );

      await this.waitForTranslation();

      $('#successPolicyModal').modal('show');
    } catch (error) {
      console.error('Error saving:', error);
      $('#errorPolicyModal').modal('show');
    }

    this.loading = false;
    this.isTranslating = false;
    this.isEditingPrivacy = false;
  }

  private async waitForTranslation(maxAttempts = 10, delayMs = 1500) {
    for (let i = 0; i < maxAttempts; i++) {
      await this.loadPolicy();

      if (this.contentEN && this.contentEN.trim()) {
        console.log('✅ Translation ready');
        return;
      }

      console.log(`⏳ Waiting translation... ${i + 1}`);
      await new Promise(res => setTimeout(res, delayMs));
    }

    console.warn('⚠️ Translation timeout');
  }

  closeModal(){
    $('#successPolicyModal').modal('hide');
    $('#errorPolicyModal').modal('hide');
  }
}
